/**
 * Created by lari on 07/06/2017.
 */
(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vcutils.zipcode.factory:Zipcode
   *
   * @description
   *
   */
  
  angular
    .module('vcutils.zipcode')
    .factory('Zipcode', Zipcode)
    .factory('Zipcodesearch', Zipcodesearch);
  
  Zipcode.$inject = ['restmod'];
  function Zipcode(restmod) {
    return restmod.model('/routes/zipcodes').mix({
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/zipcodes/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          } // $searchahead
        } // Model
      }// extend
    });
  }


  Zipcodesearch.$inject = ['restmod'];
  function Zipcodesearch(restmod) {
    return restmod.model('/routes/zipcodes/numahead');
  }
  
  
  
}());
